var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMultipleColumn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "30px",
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report-Editor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RptEd5.3-BarChartSingle",
    transform: "translate(-269.000000, -344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(269.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PivotRowValuesIcon-Copy-4",
    fill: "#FFFFFF",
    stroke: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 29,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(9.000000, 5.000000)",
    fill: "#37809F"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-4",
    fillOpacity: 0.5,
    x: 0,
    y: 9,
    width: 4,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-5",
    fillOpacity: 0.5,
    x: 13,
    y: 8,
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-6",
    stroke: "#37809F",
    x: 5.5,
    y: 4.5,
    width: 3,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-7",
    stroke: "#37809F",
    x: 18.5,
    y: 0.5,
    width: 3,
    height: 19
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMultipleColumn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/multiple_column.3a58edda55e6a19b114bf461b746c78c.svg";